export const FeatureFlagConst = {
  FF4390_CADASTRO_TERRITORIO_SISE: '4390-cadastro-territorio-sise',
  FF1182_CODIGO_LYRA_PESSOAS: '1182-codigo-lyra-pessoas',
  FF1183_CODIGO_LYRA_TERRITORIO: '1183-codigo-lyra-territorio'
};
